import React from 'react';
import { Route, IndexRoute, IndexRedirect } from 'react-router';
import { routeEntryPoint } from '../../config/route-entry-point';

// local
import Root from './modules/root/main';
import DashboardMain from './modules/dashboard/main';
import Survey from './modules/survey/main';
import Manager from './modules/manager/main';

// shared
import NotFound from '../../modules/not-found/main';
import NewsMain from '../../modules/news/main';
import OffersList from '../../modules/offers/list/main';
import OfferSingle from '../../modules/offers/single/main';
import TicketsMain from '../../modules/tickets/list/main';
import TicketItemMain from '../../modules/tickets/item/main';
import FinancesMain from '../../modules/finances/main';
import Profile from '../../modules/profile/main';
import StatGeneralMain from '../../modules/statistics/general/main';
import StatConversionsMain from '../../modules/statistics/conversions/main';
import StatAnalyticsMain from '../../modules/statistics/analytics/main';
import BannedConversionsMain from '../../modules/statistics/ban/main';
import SystemAnalyticsMain from '../../modules/statistics/system-analytics/main';
import GlobalPostback from '../../modules/global-postback/main';
import GlobalPostbackLog from '../../modules/global-postback/log';
import ResendPostback from '../../modules/global-postback/resendPostback';
import StreamsMain from '../../modules/streams/list/main';
import StreamItem from '../../modules/streams/single/main';
import Discounts from '../../modules/discounts/main';
import UserApi from '../../modules/user-api/main';
import MasterAccount from '../../modules/master-account/main';
import BmAccounts from '../../modules/bm-accounts/main';
import BmAccount from '../../modules/bm-accounts/item';
import Affiliates from '../../modules/affiliates/main';

export default (
	<Route component={Root} path={routeEntryPoint}>

		<Route path="statistics">
			<Route path="general" component={StatGeneralMain} />
			<Route path="conversions" component={StatConversionsMain} />
			<Route path="analytics" component={StatAnalyticsMain} />
			<Route path="banned" component={BannedConversionsMain} />
			<Route path="analytics/system" component={SystemAnalyticsMain} />
			<IndexRedirect to="general" />
		</Route>

		<Route path="offers">
			<Route path="public/" component={OffersList} />
			<Route path="my/" component={OffersList} />
			<Route path="affiliates/" component={OffersList} />
			<Route path=":id" component={OfferSingle} />
			<IndexRedirect to="public/" />
		</Route>

		<Route path="news(/:newsId)">
			<IndexRoute component={NewsMain} />
		</Route>

		<Route path="tickets">
			<Route path="request/:type(/:offerId)" component={TicketsMain} />
			<Route path=":ticketId" component={TicketItemMain} />
			<IndexRoute component={TicketsMain} />
		</Route>

		<Route path="finances" component={FinancesMain}>
			<Route name="history" path="history/" />
			<Route name="conversions" path="conversions/" />
			<Route name="payouts" path="payouts/" />
			<Route name="points" path="points/" />
			<IndexRedirect to="payouts/" />
		</Route>

		<Route path="profile" component={Profile} />

		<Route path="campaigns">
			<Route path="global-postback"  component={GlobalPostback}/>
			<Route path="global-postback/log"  component={GlobalPostbackLog}/>
			<Route path="global-postback/resend"  component={ResendPostback}/>
			<Route path="new"  component={StreamItem}>
				<Route path=":offerId" component={StreamItem}/>
			</Route>
			<Route path=":streamId" component={StreamItem} />
			<IndexRoute component={StreamsMain} />
		</Route>

		<Route path="dashboard" component={DashboardMain}>
			<Route name="week-chart" path="week-chart/" />
			<Route name="day-chart" path="day-chart/" />
			<IndexRedirect to="week-chart/" />
		</Route>

		<Route path="user-api">
			<IndexRoute component={UserApi} />
		</Route>
		<Route path="discounts">
			<IndexRoute component={Discounts} />
		</Route>

		<Route path="master-account">
			<IndexRoute component={MasterAccount} />
		</Route>

		<Route path="bm-accounts">
			<IndexRoute component={BmAccounts} />
			<Route path=":id" component={BmAccount} />
		</Route>

		<Route path="affiliates" component={Affiliates} />

		<IndexRedirect to="dashboard/week-chart/" />

		<Route path="survey" component={Survey} />
		<Route path="manager" component={Manager} />

		<Route path="*" component={NotFound} />
	</Route>
);



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/routes.js